export const STRIPE_ID = "pk_live_PsMmbdMS6qsptv9VeTHO083h00IZdYdFgr";     //pk_live_PsMmbdMS6qsptv9VeTHO083h00IZdYdFgr    | pk_test_KkLsoKDyaOQqoCeKpJl8Udme00eQ0TUbIw

export const PAYMENT_TAB = {
    MONTHLY: "monthly",
    ONCE: "once"
}